import { createContext } from 'react'

export type FieldContextType = {
  id: string
  name: string
  error: boolean
  warning: boolean
  disabled: boolean
  onChange(value: unknown): void
  grow: boolean
  required: boolean
}

export const FieldContext = createContext<FieldContextType | null>(null)

export type FormContextType = {
  validity: Record<string, string>
  onChange: (field: string, value?: unknown) => void
  submitCount: number
  startUpload: () => () => void
}

export const FormContext = createContext<FormContextType | null>(null)
